import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isShow: false,
  alertData: {
    variant: 'filled',
    severity: 'success',
    message: '',
    alertTitle: '',
    timeoutHide: 5000,
  },
}

export const getIsShowNotificationSelector = (state) =>
  state.notification.isShow

export const getNotificationDataSelector = (state) =>
  state.notification.alertData

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showAlert(state, action) {
      state.isShow = true
      state.alertData = { ...initialState.alertData, ...action.payload }
    },
    hideAlert(state) {
      state.isShow = false
      state.alertData = initialState.alertData
    },
  },
})

export const { showAlert, hideAlert } = notificationSlice.actions

export default notificationSlice.reducer
